const RANK_ORDER = ['2', '3', '4', '5', '6', '7', '8', '9', '10', 'J', 'Q', 'K', 'A'];
const SUIT_ORDER = ['S', 'H', 'C', 'D'];
const IS_BLACK = { S: true, C: true, D: false, H: false };

export const sortCards = (cards, trump) => {
    const bySuit = { C: [], D: [], H: [], S: [] };
    for (const card of cards) bySuit[card.suit].push(card);

    const sortSuit = (suitCards) =>
        [...suitCards].sort((a, b) => RANK_ORDER.indexOf(a.rank) - RANK_ORDER.indexOf(b.rank));

    let order;
    if (trump) {
        const rest = SUIT_ORDER.filter(s => s !== trump);
        const blacks = rest.filter(s => IS_BLACK[s]);
        const reds = rest.filter(s => !IS_BLACK[s]);
        const [first, second] = IS_BLACK[trump] ? [reds, blacks] : [blacks, reds];
        order = [trump];
        let a = 0, b = 0;
        for (let i = 0; i < rest.length; i++) {
            order.push(i % 2 === 0 ? first[a++] : second[b++]);
        }
    } else {
        order = SUIT_ORDER;
    }

    return order.flatMap(s => sortSuit(bySuit[s]));
};
